module.exports = __webpack_public_path__ + "static/media/dispenser.fe0d69f3.png";